import * as React from "react";
import { Inbox } from "lucide-react";
import { cn } from "@/lib/utils";

export function EmptyState({ icon: Icon = Inbox, title, description, action, className, ...props }) {
    return (
        <div
            className={cn(
                "py-12 px-6 flex flex-col items-center justify-center text-center",
                className,
            )}
            {...props}
        >
            <div className="w-16 h-16 rounded-full bg-[#EEF7FC] text-bio-accent flex items-center justify-center mb-4">
                <Icon className="h-7 w-7" />
            </div>
            <h3 className="text-lg font-bold text-bio-text">{title}</h3>
            {description && (
                <p className="text-sm text-bio-text-secondary max-w-sm mt-1 mb-6">{description}</p>
            )}
            {action}
        </div>
    );
}
